import { Quote, AlertTriangle } from "lucide-react";
import { ONLINE_PROBLEMS } from "@/lib/content";
import { Reveal, SectionLabel } from "@/components/landing/Reveal";

export const OnlineProblems = () => (
  <section className="relative bg-ink2 px-4 py-16 sm:px-8 lg:py-24" data-testid="online-problem-section">
    <div className="mx-auto max-w-6xl">
      <Reveal className="max-w-2xl">
        <SectionLabel>Why Learning Alone Doesn't Work</SectionLabel>
        <h2 className="mt-4 font-display text-5xl font-bold uppercase leading-none tracking-tight text-offwhite sm:text-6xl">
          Sound Familiar?
        </h2>
      </Reveal>

      <div className="mt-10 grid gap-4 md:grid-cols-6">
        {ONLINE_PROBLEMS.map((p, i) => (
          <Reveal key={p.title} delay={i * 0.06} className={i < 2 ? "md:col-span-3" : "md:col-span-2"}>
            <div className="group h-full rounded-2xl border border-surfaceline bg-surface p-6 transition-colors duration-300 hover:border-red-500/40">
              <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-xl border border-red-500/20 bg-red-500/10 text-red-400">
                <AlertTriangle size={20} strokeWidth={1.6} />
              </div>
              <h3 className="font-heading text-xl font-bold text-offwhite">{p.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-mutedgreen">{p.body}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <div className="mt-8 flex items-start gap-4 rounded-2xl border border-surfaceline bg-surface p-6 sm:p-8">
          <span className="mt-1 h-full w-1 shrink-0 rounded-full bg-gradient-to-b from-gold to-em2" />
          <Quote size={30} className="shrink-0 text-gold/70" />
          <p className="font-display text-2xl font-semibold leading-tight text-offwhite sm:text-3xl">
            All five come from trading without a plan or a mentor. In 90 days,
            you'll have both.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
